import React from 'react';
import { FaFacebookF, FaInstagram, FaYoutube } from 'react-icons/fa';
import modakLogo from '../assets/bb glam .png';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content container">
        <div className="footer-info">
          <div className="footer-logo">
            <img src={modakLogo} alt="BB Glam Beauty Parlour Logo" />
          </div>
          <h2>BB Glam Beauty Parlour</h2>
          <p>Phone: <a href="tel: +919182984972">+91 9182984972</a></p>
          <p>Email: <a href="mailto:bbglambeautyparlour@gmail.com">bbglambeautyparlour@gmail.com</a></p>
        </div>
        <div className="footer-social">
          <a href="https://www.instagram.com/bb_glam_unisex_salon/" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FaInstagram /></a>
          <a href="https://www.youtube.com/@bbglambeautyparlour" target="_blank" rel="noopener noreferrer" aria-label="YouTube"><FaYoutube /></a>
          <a href="https://www.facebook.com/profile.php?id=61579457169371" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><FaFacebookF /></a>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="footer-copyright">
          &copy; {new Date().getFullYear()} BB Glam Beauty Parlour. All rights reserved.
        </div>
        <div className="footer-designed-by">
          Designed by <a href="https://jnitdigitalmarketing.com/" target="_blank" rel="noopener noreferrer">JN IT</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
